import { ICrudLocale } from '@app/i18n/interface';

export const HOTEL_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  HOTEL: {
    LABEL: {
      SINGULAR: 'Hotel',
      PLURAL: 'Hoteles',
    },
    FIELD: {
      DESTINATION: 'Destino',
      DESTINATION_PLACEHOLDER: 'Ciudad, zona o nombre del hotel',
      CHECK_IN: 'Entrada',
      CHECK_OUT: 'Salida',
      DATE_PLACEHOLDER: 'dd/mm/aaaa',
      ROOMS: 'Habitaciones',
      ROOMS_ONE: '1 habitación',
      ROOMS_N: '{{n}} habitaciones',
      ADULTS: 'Adultos por habitación',
      ADULTS_ONE: '1 adulto',
      ADULTS_N: '{{n}} adultos',
      CHILDREN: 'Niños por habitación',
      CHILDREN_ONE: '1 niño',
      CHILDREN_N: '{{n}} niños',
      CHILD_AGE: 'Edad del niño {{n}}',
      CHILD_AGE_PLACEHOLDER: 'Elige la edad',
      AGE_BABY: 'Bebé (menos de 1 año)',
      AGE_ONE: '1 año',
      AGE_N: '{{n}} años',
      SOURCE_MARKET: 'País de origen',
      HOTEL_CODES: 'Hoteles concretos (opcional)',
      HOTEL_CODES_PLACEHOLDER: 'Por ejemplo 113657, 357246',
      HOTEL_CODES_HELP: 'Si los rellenas, se buscan solo esos hoteles, separados por comas.',
      BOARD: 'Régimen',
      PRICE: 'Precio de venta',
      RATE_KEY: 'Clave de tarifa (rateKey)',
      CANCEL_FREE_ALWAYS: 'Cancelación gratuita (ningún tramo penaliza)',
      CANCEL_FREE_UNTIL: 'Gratis hasta el {{date}}{{utc}}',
      CANCEL_THEN: 'luego {{amount}}',
      CANCEL_EXPIRED: 'ventana ya vencida',
      CANCEL_UNKNOWN: 'Cancelación: el proveedor no informó',
    },
    SEARCH: {
      TITLE: 'Búsqueda de hoteles',
      SUBTITLE: 'Consulta la disponibilidad y las tarifas que ve el cliente, sin pasar por la web pública.',
      FORM_TITLE: 'Datos de la búsqueda',
      FORM_SUBTITLE: 'Cada búsqueda es una consulta real de disponibilidad a Hotelbeds.',
      SUBMIT: 'Buscar',
      SEARCHING_BUTTON: 'Buscando',
      RESET: 'Limpiar',
      SEARCHING: 'Buscando…',
      NO_MATCHES: 'Sin coincidencias',
      GROUP_DESTINATIONS: 'Destinos',
      GROUP_HOTELS: 'Hoteles',
      CLEAR_LOCATION: 'Borrar el destino',
      SUGGESTIONS: 'Sugerencias de destinos y hoteles',
    },
    RESULTS: {
      TITLE: 'Resultados',
      CAPTION: 'Hoteles con disponibilidad',
      SUMMARY: '{{hotels}} con disponibilidad para {{nights}}, {{guests}} y {{rooms}}. Precios en {{currency}}.',
      HOTELS_ONE: '1 hotel',
      HOTELS_N: '{{n}} hoteles',
      NIGHTS_ONE: '1 noche',
      NIGHTS_N: '{{n}} noches',
      LOADING: 'Consultando disponibilidad en Hotelbeds',
      LOADING_HINT: 'Puede tardar unos segundos. Los resultados aparecerán aquí.',
      COL_HOTEL: 'Hotel',
      COL_DESTINATION: 'Destino',
      COL_CATEGORY: 'Categoría',
      COL_BOARD: 'Régimen de la tarifa más baja',
      COL_BOARD_SHORT: 'Régimen',
      FROM: 'Desde',
      RATES: '{{n}} tarifas',
      RATES_ONE: '1 tarifa',
      CODE: 'Código {{code}}',
      STARS: '{{n}} estrellas',
      BOARD_FILTER: 'Régimen',
      BOARD_ANY: 'Cualquier régimen',
      PAGINATION: 'Páginas de resultados',
      SHOWING: 'Mostrando {{from}}-{{to}} de {{total}}',
      PAGE: 'Página {{page}} de {{pages}}',
      PREVIOUS: 'Anterior',
      NEXT: 'Siguiente',
      EMPTY: 'No hay hoteles con disponibilidad para esa búsqueda. Prueba con otras fechas u otro destino.',
      ERROR_TITLE: 'No se ha podido consultar la disponibilidad',
      ERROR: 'Vuelve a intentarlo dentro de un momento. Si sigue fallando, avisa al equipo técnico.',
    },
    VALIDATION: {
      DATES_REQUIRED: 'Elige las fechas de entrada y salida.',
      CHECKOUT_AFTER_CHECKIN: 'La salida tiene que ser posterior a la entrada.',
      TOO_MANY_NIGHTS: 'Como mucho puedes buscar 30 noches.',
      TOO_MANY_GUESTS: 'Como mucho caben 5 personas por habitación.',
      CHILD_AGES: 'Indica la edad de cada niño.',
      DESTINATION_OR_CODES: 'Elige un destino o un hotel de la lista, o escribe el código de algún hotel.',
    },
  },
};
